import { useProfessionalInitialRouteData } from '@modules/professional/hook/use-professional-initial-route-data';
import { DetailCreditsRow } from '~/ui-rocco/pages/detail-shared';

/**
 * The product page's meta row, on the profile: the practice's services as
 * the tags, then the cities they work from and the bodies they belong to as
 * the two columns of names. Each hides when empty; the row hides when all
 * three are.
 */
export const ProfessionalMetaRow = () => {
    const initial = useProfessionalInitialRouteData();
    if (!initial) return null;

    const services = Array.from(
        new Set(
            (initial.Services ?? [])
                .map((service) => service.trim())
                .filter((service) => service !== ''),
        ),
    ).map((label) => ({ label }));

    const locations = Array.from(
        new Set(
            (initial.LibraryLocations ?? [])
                .filter((location) => !location.LocationHidden)
                .map((location) => location.City?.trim())
                .filter((city): city is string => Boolean(city)),
        ),
    ).map((name) => ({ name }));

    const associations = Array.from(
        new Set(
            (initial.Associations ?? [])
                .map((association) => association.Title?.trim())
                .filter((title): title is string => Boolean(title)),
        ),
    ).map((name) => ({ name }));

    return (
        <DetailCreditsRow
            tags={services}
            columns={[
                {
                    label: 'Locations',
                    entries: locations,
                    columns: locations.length > 5 ? 2 : 1,
                },
                { label: 'Associations', entries: associations },
            ]}
        />
    );
};
